import React from 'react';
import {Route, RouteProps} from "react-router";

const WORKBENCH_TITLE = "OTP Workbench";

/**
 * Custom route that allows to change the document's title when the route renders.
 */
export function WorkbenchRoute(props: RouteProps & { pageTitle?: string }) {
  const PageComponent = props.component;
  // component is overridden to avoid conflict with the overridden render property
  // only one of them may be defined
  return <Route {...props} component={undefined} render={renderProps => {
    // Update title
    updatePageTitle(WORKBENCH_TITLE, props.pageTitle);
    // Render the given component
    if (PageComponent) {
      return <PageComponent {...renderProps} />;
    } else if (props.render) {
      // Or use the given render function
      return props.render(renderProps);
    }
    // Not handled
    return null;
  }}/>
}

function updatePageTitle(baseTitle: string, title?: string) {
  if (title && title.length) {
    document.title = `${title} | ${baseTitle}`;
  } else {
    document.title = baseTitle;
  }
}
